// Because IE doesn't have shadow DOM, Stencil adds a class "sc-c-bubble" to each element
// to scope the styles to this class. However it does not do that for innerHTML elements, so we need to add the class ourselves
export function fixIEShadowDom(text: string, componentName: string): string {
    if (!text) {
        return "";
    }
    const addedToLinks = text.replace(/<a/g, `<a class='sc-${componentName}'`);
    return addedToLinks.replace(/<img/g, `<img class='sc-${componentName}'`);
}
